/**
 * Hero Video Email Signup
 * Handles form validation and submission for Shopify newsletter subscription
 * Uses hidden iframe for native form submission without page refresh
 */

(function() {
  'use strict';

  var EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var iframeCounter = 0;

  function initSignupForm(container) {
    var form = container.querySelector('form');
    var emailInput = container.querySelector('[data-signup-email]');
    var submitBtn = container.querySelector('[data-signup-submit]');
    var errorMsg = container.querySelector('[data-signup-error]');
    var successMsg = container.querySelector('[data-signup-success]');

    if (!form || !emailInput) return;

    // Create unique iframe name for this form
    var iframeName = 'signup-iframe-' + (++iframeCounter);
    
    // Create hidden iframe for form submission
    var iframe = document.createElement('iframe');
    iframe.name = iframeName;
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    
    // Set form to target the hidden iframe
    form.setAttribute('target', iframeName);
    
    // Ensure form action is correct (Shopify should set this, but be explicit)
    if (!form.getAttribute('action') || form.getAttribute('action') === '') {
      form.setAttribute('action', '/contact#contact_form');
    }
    
    // Real-time validation on input
    emailInput.addEventListener('input', function() {
      container.classList.remove('hero-video-signup--error');
      errorMsg.hidden = true;
    });

    // Clear error on focus
    emailInput.addEventListener('focus', function() {
      container.classList.remove('hero-video-signup--error');
      errorMsg.hidden = true;
    });

    // Form submission
    form.addEventListener('submit', function(e) {
      var email = emailInput.value.trim();

      // Validate email format
      if (!email || !EMAIL_REGEX.test(email)) {
        e.preventDefault();
        showError(container, errorMsg);
        return false;
      }

      // Set loading state
      container.classList.add('hero-video-signup--loading');
      submitBtn.disabled = true;

      // Listen for iframe load (indicates form submitted)
      var loadHandler = function() {
        iframe.removeEventListener('load', loadHandler);
        
        // Small delay to ensure Shopify processes the submission
        setTimeout(function() {
          container.classList.remove('hero-video-signup--loading');
          submitBtn.disabled = false;
          showSuccess(container, successMsg, emailInput);
        }, 500);
      };
      
      iframe.addEventListener('load', loadHandler);
      
      // Let form submit naturally to iframe
      return true;
    });
  }

  function showError(container, errorMsg) {
    container.classList.add('hero-video-signup--error');
    errorMsg.hidden = false;
  }

  function showSuccess(container, successMsg, emailInput) {
    container.classList.remove('hero-video-signup--error');
    container.classList.add('hero-video-signup--success');
    successMsg.hidden = false;
    
    // Clear the input for potential re-use
    if (emailInput) {
      emailInput.value = '';
    }
  }

  function initAllSignupForms() {
    document.querySelectorAll('[data-hero-signup]').forEach(initSignupForm);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSignupForms);
  } else {
    initAllSignupForms();
  }

  // Shopify theme editor integration
  document.addEventListener('shopify:section:load', function(event) {
    event.target.querySelectorAll('[data-hero-signup]').forEach(initSignupForm);
  });

})();
